import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface RecurrenceEditorRowProps {
  label: ReactNode;
  content: ReactNode;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: grid;
  grid-row-gap: 6px;
`;

const StyledLabelDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  color: ${(p) => p.theme.greys.shade70};
`;

/*
 * Component.
 */

export const RecurrenceEditorRow: FC<RecurrenceEditorRowProps> = (props) => (
  <StyledWrapperDiv>
    <StyledLabelDiv>{props.label}</StyledLabelDiv>
    <div>{props.content}</div>
  </StyledWrapperDiv>
);
